document.addEventListener("DOMContentLoaded", function () {
  const rulesLinks = document.querySelectorAll(".rules-link");
  const closeBtns = document.querySelectorAll(".close-btn");
  const overlays = document.querySelectorAll(".modal-overlay");

  rulesLinks.forEach((link) => {
    link.addEventListener("click", function (e) {
      e.preventDefault();
      const promoId = this.getAttribute("data-promo");
      const modal = document.getElementById("modal-" + promoId);

      if (modal) {
        modal.classList.remove("hidden");
      }
    });
  });

  closeBtns.forEach((btn) => {
    btn.addEventListener("click", function () {
      const promoId = this.getAttribute("data-promo");
      const modal = document.getElementById("modal-" + promoId);

      if (modal) {
        modal.classList.add("hidden");
      }
    });
  });

  overlays.forEach((overlay) => {
    overlay.addEventListener("click", function () {
      const modal = this.closest(".modal");

      if (modal) {
        modal.classList.add("hidden");
      }
    });
  });
});
